<template>
	<div class="px-4 pb-5">
		<general-filter class="wrap px-0 mt-4 mb-0">
			<v-flex xs12 sm6>
				<BaseSelect
					:height="38"
					item-text="name"
					item-value="value"
					:items="states"
					label="Estado"
					v-model="params.flagAssigned"
					@input="onChangeFlag"
				/>
			</v-flex>
		</general-filter>
		<rules-assign-list
			:check-all="checkAll"
			:columns="columns"
			:current-page="currentPage"
			:is-assigned="params.flagAssigned"
			:last-page="table.lastPage"
			:rows="table.rows"
			@on-delete="onDelete"
			@on-page="onPage"
			@on-search="onSearchTable"
			@on-selected-all="onSelectedAll"
			@row-is-selected="rowIsSelected"
			@load-data="loadData('rules');"
		/>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="submitForm"
				:is-loading="disabled"
				:hiddenSaveBtn="this.params.flagAssigned"
			></modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	import rulesAssignList from '@/components/rules/rules-assign-list';

	async function created() {
		this.params.subsidiaryId = this.subsidiaryId;
		this.params.definitionId = this.definitionId;
		this.params.moduleId = this.moduleId;
		this.params.flagAssigned = this.states[0].value;
		this.loadData('rules');
	}

	function disabled() {
		return this.loading || this.dataSelected.length === 0;
	}

	function onChangeFlag(value) {
		this.params.flagAssigned = value;
		this.dataSelected = [];
		this.returnColumns(value);
		this.loadData('rules');
	}

	function onDelete(row) {
		this.dataSelected.push(row.id);
		const index = this.table.rows.findIndex(r => r.id === row.id);
		if (index > -1) {
			this.table.rows.splice(index, 1);
		}
	}

	function onPage(page) {
		this.currentPage = page;
		this.params.page = page;
		this.loadData('rules');
	}

	function onSearchTable(search) {
		this.params.page = 1;
		this.currentPage = 1;
		this.onSearch(search, 'rules');
	}

	function onSelectedAll(checked) {
		this.checkAll = checked;
		this.table.rows = this.table.rows.map((row) => {
			const newRow = { ...row };
			newRow.isSelected = checked;
			return newRow;
		});
		this.dataSelected = this.table.rows.filter(r => r.isSelected);
	}

	function returnColumns(value) {
		if (value) {
			this.columns = [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
				{ id: 3, name: 'Editar', value: 'flagEdit', checked: true, visible: true },
				{ id: 4, name: 'Debe / Haber', value: 'sign', checked: true, visible: true },
				{ id: 5, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			];
		} else {
			this.columns = [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
				{ id: 3, name: 'Editar', value: 'flagEdit', checked: true, visible: true },
				{ id: 4, name: 'Debe / Haber', value: 'sign', checked: true, visible: true },
			];
		}
	}

	function rowIsSelected() {
		this.checkAll = this.table.rows.every(r => r.isSelected);
		this.dataSelected = this.table.rows.filter(r => r.isSelected);
	}

	async function submitForm() {
		this.loading = true;
		const method = !this.params.flagAssigned ? 'post' : 'delete';
		const action = !this.params.flagAssigned ? 'asignación' : 'eliminación';
		const url = !this.params.flagAssigned ? 'accounting-definition-details-create' :
			'accounting-definition-details';
		const body = !this.params.flagAssigned ? this.dataSelected.map((ds) => {
			const newDs = {
				ruleId: ds.id,
				sign: ds.sign || 2,
				flagEdit: !!ds.flagEdit,
			};
			return newDs;
		}) : { data: { ruleIds: this.dataSelected } };
		try {
			await this.$http[method](`${url}/${this.definitionId}`, body);
			this.showNotification(`La ${action} se realizó correctamente`);
			this.$emit('close-modal');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function data() {
		return {
			checkAll: false,
			columns: [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
				{ id: 3, name: 'Editar', value: 'flagEdit', checked: true, visible: true },
				{ id: 4, name: 'Debe / Haber', value: 'sign', checked: true, visible: true },
			],
			currentPage: 1,
			dataSelected: [],
			loading: false,
			states: [
				{ id: 1, name: 'Sin asignar', value: false },
				{ id: 2, name: 'Asignadas', value: true },
			],
		};
	}

	export default {
		name: 'rules-assign-form',
		components: {
			rulesAssignList,
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
		},
		computed: {
			disabled,
		},
		created,
		data,
		methods: {
			onChangeFlag,
			onDelete,
			onPage,
			onSearchTable,
			onSelectedAll,
			returnColumns,
			rowIsSelected,
			submitForm,
		},
		props: {
			definitionId: [Number, String],
			subsidiaryId: [Number, String],
			moduleId: [Number, String],
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/rules/rules-assign-form.vue